'use strict';

require('../../modules/es.object.create');
var path = require('../../internals/path');
var Object = path.Object;
module.exports = function create(P, D) {
  return Object.create(P, D);
};